import gql from 'graphql-tag';

export const SaveApplicationPaymentMutation = gql`
  mutation ($applicationPayment: ApplicationPaymentInput!, $applicationPaymentId: String) {
    saveApplicationPayment (applicationPayment: $applicationPayment, applicationPaymentId: $applicationPaymentId) 
    {
      id
    }
  }
`;

